module.exports = __webpack_public_path__ + "media/img/favicon-32x32-db1ad8492fc3145e2a82f1642ee0a183.png";